import { render, staticRenderFns } from "./MainApplicant.vue?vue&type=template&id=760be4ea&"
import script from "./MainApplicant.vue?vue&type=script&lang=js&"
export * from "./MainApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports